<template>
  <v-sheet
    :id="`${props.target}`"
    :color="props.color_background ? props.color_background : '#FFFFFF'"
    :class="`
      pt-${props.pt ? props.pt : '0'} 
      pb-${props.pb ? props.pb : '0'}`">
    <v-container fluid v-if="props" class="container-padding py-8">
      <v-row align="stretch">
        <v-col
          v-for="(box, boxIndex) in boxes"
          :key="boxIndex"
          cols="12"
          md="6"
          lg="6">
          <v-sheet
            height="100%"
            class="rounded-lg pa-6"
            :color="props.color_box ? props.color_box : '#FFFFFF'"
            :style="`border: 1px solid ${box.color}`">
            <!-- Box headline -->
            <v-row
              v-if="box.headline && box.headline[language]"
              align="start"
              class="mb-2 flex-nowrap"
              no-gutters>
              <v-icon v-if="box.icon" :color="box.color" class="mr-2 mt-1">
                {{ box.icon }}
              </v-icon>
              <h3
                class="text-h6 font-weight-bold"
                :style="`color: ${box.color}; min-width: 0`"
                v-html="box.headline[language]"></h3>
            </v-row>
            <!-- Items -->
            <div v-for="(item, itemIndex) in box.items" :key="itemIndex">
              <v-divider v-if="itemIndex > 0" class="my-4"></v-divider>
              <v-row align="start" no-gutters>
                <v-col v-if="item.img" cols="auto" class="pr-4">
                  <v-icon
                    v-if="isIcon(item.img)"
                    :color="box.color"
                    :size="props.img_width ? props.img_width : 48">
                    {{ item.img }}
                  </v-icon>
                  <img
                    v-else
                    :src="item.img"
                    :width="`${props.img_width ? props.img_width : 48}px`" />
                </v-col>
                <v-col>
                  <h4
                    v-if="item.headline && item.headline[language]"
                    class="mb-1 text-subtitle-1 font-weight-bold"
                    v-html="item.headline[language]"></h4>
                  <div
                    v-if="item.text && item.text[language]"
                    class="text-body-2"
                    v-html="item.text[language]"></div>
                </v-col>
              </v-row>
            </div>
          </v-sheet>
        </v-col>
      </v-row>

      <!-- Edit dialog -->
      <v-dialog v-if="edit" persistent v-model="edit" fullscreen>
        <v-card>
          <v-card-title class="text-h5 black white--text">
            Edit Component
          </v-card-title>
          <v-card-text class="pt-5">
            <Core
              name="Core"
              :editProps="editProps"
              @emitProps="setPreviewProps"
              @save="save"
              @cancel="cancel" />
            <!-- Preview -->
            <h2 class="my-2 text-h4 black--text">Preview:</h2>
            <CompInfoBoxes
              v-if="previewProps"
              name="CompInfoBoxes"
              :props="previewProps" />
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import CompInfoBoxes from "./CompInfoBoxes";
import Core from "../editor/Core.vue";

export default {
  name: "CompInfoBoxes",
  props: ["props", "edit", "index", "componentId"],
  data() {
    return {
      editProps: {},
      previewProps: null,
    };
  },
  watch: {
    edit: function () {
      this.editProps.target = this.props.target ?? "";
      this.editProps.pt = this.props.pt ?? 0;
      this.editProps.pb = this.props.pb ?? 0;

      this.setEditProp("color_background", "color", "#FFFFFF");
      this.setEditProp("color_box", "color", "#FFFFFF");
      this.setEditProp("img_width", "number", 48);

      for (const box of [1, 2]) {
        this.setEditProp(`box_${box}_color`, "color", "#eb002e");
        this.setEditProp(`box_${box}_icon`, "link", "mdi-information-outline");
        this.setEditProp(`box_${box}_headline`, "text", {});
        for (const item of [1, 2, 3]) {
          this.setEditProp(`box_${box}_img_href_${item}`, "image", "");
          this.setEditProp(`box_${box}_headline_${item}`, "text", {});
          this.setEditProp(`box_${box}_text_${item}`, "text", {});
        }
      }
    },
  },
  computed: {
    ...mapState({
      language: state => {
        return state.language ?? "de";
      },
    }),
    boxes: function () {
      const p = this.props ?? {};
      const filled = value => value && value[this.language];
      return [1, 2]
        .map(box => ({
          color: p[`box_${box}_color`] ?? "#eb002e",
          icon: p[`box_${box}_icon`] ?? "mdi-information-outline",
          headline: p[`box_${box}_headline`],
          items: [1, 2, 3]
            .map(item => ({
              img: p[`box_${box}_img_href_${item}`],
              headline: p[`box_${box}_headline_${item}`],
              text: p[`box_${box}_text_${item}`],
            }))
            .filter(item => filled(item.headline) || filled(item.text)),
        }))
        .filter(box => filled(box.headline) || box.items.length);
    },
  },
  methods: {
    isIcon(value) {
      return String(value).startsWith("mdi-");
    },
    setEditProp(name, type, fallback) {
      this.editProps[name] = {
        type: type,
        name: name,
        value: this.props[name] ?? fallback,
      };
    },
    save(previewProps) {
      this.previewProps = JSON.parse(JSON.stringify(previewProps));
      this.$emit("save", this.previewProps, this.index, this.componentId);
    },
    cancel() {
      this.$emit("cancel");
    },
    setPreviewProps(previewProps) {
      this.previewProps = JSON.parse(JSON.stringify(previewProps));
    },
  },
  components: {
    Core,
    CompInfoBoxes,
  },
};
</script>

<style></style>
